module.exports = (theme) => ({
  ".details summary": {
    cursor: "pointer",
    color: theme("colors.primary.black.DEFAULT"),
    outline: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    "list-style-type": "none !important",
  },
  ".details[disabled] summary": {
    cursor: "default",
    color: theme("colors.tertiary.lightgrey"),
    "user-select": "none",
    "pointer-events": "none",
  },
  ".details[readonly] summary": {
    cursor: "default",
    color: theme("colors.tertiary.mediumgrey"),
    "user-select": "none",
    "pointer-events": "none",
  },
  ".details summary::-webkit-details-marker": {
    display: "none",
    content: "''",
  },
  ".details summary::marker": {
    display: "none",
    content: "''",
  },
  ".details summary::after": {
    color: "black !important",
    fontFamily: theme("fontFamily.icons"),
    fontSize: theme("fontSize.lg"),
    paddingLeft: theme("spacing.DEFAULT"),
    minHeight: "100%",
    content: '"\\e981"',
  },
  ".details summary:only-child::after, .details[open] summary:only-child::after": {
    content: "''",
  },
  ".details summary:only-child, .details[open] summary:only-child": {
    cursor: "default",
  },
  ".details[disabled] summary::after": {
    color: `${theme("colors.tertiary.lightgrey")} !important`,
  },
  ".details[readonly] summary::after": {
    color: `${theme("colors.tertiary.mediumgrey")} !important`,
  },
  ".details[open] summary::after": {
    content: '"\\e98c"',
  },
});
